import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import axios from "axios";
import "@/core/services/mixins";
//import ApiService from "@/core/services/api.service";
//import MockService from "@/core/mock/mock.service";
//import { VERIFY_AUTH } from "@/core/services/store/auth.module";
//import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";

window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";

window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
//import "@/core/plugins/formvalidation";

import vSelect from 'vue-select'
Vue.component('v-select2', vSelect)

// API service init
//ApiService.init();

// Remove this to disable mock API
//MockService.init();

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.guestAccess)) {
        next()
    } else if (!store.getters.isLoggedIn) {
        next('/login')
    } else {
        let userData = store.getters.getUserData
        if (!userData || !userData.Session_UID) {
            next('/login')
        } else {
            if (to.meta.accessPage && userData.UserAccess.filter(function (el) {
                return (el.AccessObject.toLowerCase() === to.meta.accessPage.toLowerCase()
                    && parseInt(el.AccessMask) > 1)
            }).length === 0) {
                next('/')
            } else {
                //session validate
                axios.post("/ws/ws.svc/UserSessionValidate", {'Session_UID': userData.Session_UID},
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (!resp.data.response.toString().length && typeof resp.data.success !== "undefined"
                            && resp.data.success
                        ) {
                            next()
                        } else {
                            console.log(resp.data.response.toString())
                            next('/login')
                        }
                    })
                    .catch(err => {
                        console.log("Ошибка при отправке данных (" + err.message + ")")
                        next('/login')
                    })

            }

        }
    }
})


new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount("#app");
